import { NgModule } from '@angular/core';
import { TextAvatarDirective } from './text-avatar/text-avatar';

@NgModule({
	declarations: [TextAvatarDirective],
	imports: [],
	exports: [TextAvatarDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts